import React from 'react';

import type { NewCoreIconProps } from '@atlaskit/icon';
import ChangesIcon from '@atlaskit/icon/core/changes';
import BitbucketCompareIconLegacy from '@atlaskit/icon/glyph/bitbucket/compare';

export const CompareIcon: React.FunctionComponent<NewCoreIconProps> = (props) => (
	<ChangesIcon {...props} label="" LEGACY_fallbackIcon={BitbucketCompareIconLegacy} />
);
